<template>
<sidebar-widget
    v-if="dataLoaded"
    :start-expanded="true"
    :sections="sections"
    :headers="[{label: 'Plan'}, {label: 'Balance', classes: 'cw-8'}]"
>
    <template v-slot:title>Time Off</template>

    <template v-slot:headerbutton>
        <button v-if="availablePlans.length" class="btn btn-outline-primary" @click.prevent.stop="openModal('enroll')"><i class="far fa-plus"></i> Enroll</button>
    </template>

    <template v-slot:row-details="props">
        <div>
            <div>Type: {{ props.row.obj.plan_type_pretty }} &middot; {{ props.row.obj.method_pretty }}</div>
            <div>Enrolled: {{ $filters.date(props.row.obj.start_date) }} &ndash; {{ props.row.obj.end_date ? $filters.date(props.row.obj.end_date) : 'Present' }}</div>
            <div>Tenure Date: {{ $filters.date(props.row.obj.tenure_date) }} (Tier {{ props.row.obj.tier_number }})</div>
            <div>Accrued This Year: {{ hours(props.row.obj.ytd_accrued) }}</div>
            <div>Used This Year: {{ hours(props.row.obj.ytd_used) }}</div>

            <button class="btn btn-outline-primary mb-2" @click.prevent="openLedger(props.row.obj)">History</button>
            <div v-if="props.row.obj.can_edit">
                <button class="btn btn-outline-primary mb-2" @click.prevent="openModal('adjust', props.row.obj)">Adjust Balance</button> <br />
                <button class="btn btn-outline-primary mb-2" @click.prevent="openModal('tenure', props.row.obj)">Tenure Date</button> <br />
                <button class="btn btn-outline-primary mb-2" @click.prevent="openModal('switch', props.row.obj)">Switch Plan</button> <br />
                <button class="btn btn-outline-primary mb-2" @click.prevent="openModal('end', props.row.obj)">End</button> <br />
            </div>
        </div>
    </template>

    <template v-slot:extra>
        <time-off-modal
            v-if="modalMode"
            :mode="modalMode"
            :client="client"
            :employee="employee"
            :enrollment="currentEnrollment"
            :available-plans="availablePlans"
            :default-tenure-date="defaultTenureDate"
            @updated="onUpdated"
            @close="modalMode = null"
        />
        <time-off-ledger-modal
            v-if="ledgerOpen"
            :client="client"
            :employee="employee"
            :enrollment="currentEnrollment"
            @close="ledgerOpen = false"
        />
    </template>
</sidebar-widget>
</template>

<script>
import SidebarWidget from '@/components/SidebarWidget'
import ButtonRow from '@/components/ButtonRow'
import TimeOffModal from './TimeOffModal'
import TimeOffLedgerModal from './TimeOffLedgerModal'

export default {
    props: ['employee', 'client', ],
    components: {SidebarWidget, ButtonRow, TimeOffModal, TimeOffLedgerModal, },
    data() {
        return {
            dataLoaded: false,
            enrollments: [],
            availablePlans: [],
            defaultTenureDate: null,
            modalMode: null,
            ledgerOpen: false,
            currentEnrollment: null,
        }
    },
    computed: {
        sections() {
            const toRow = e => ({
                obj: e,
                id: e.id,
                cells: [e.plan_name, this.hours(e.balance)],
            })
            return [
                {title: 'Current', rows: this.enrollments.filter(e => e.is_current).map(toRow), startExpanded: true},
                {title: 'Ended', rows: this.enrollments.filter(e => !e.is_current).map(toRow), startExpanded: false},
            ]
        },
    },
    mounted() {
        this.getData()
    },
    methods: {
        hours(value) {
            return `${Number(value).toFixed(2)} hrs`
        },
        openModal(mode, enrollment) {
            this.currentEnrollment = enrollment || null
            this.modalMode = mode
        },
        openLedger(enrollment) {
            this.currentEnrollment = enrollment
            this.ledgerOpen = true
        },
        setData(resp) {
            this.enrollments = resp.enrollments
            this.availablePlans = resp.available_plans
            this.defaultTenureDate = resp.default_tenure_date
            this.dataLoaded = true
        },
        onUpdated(resp) {
            this.setData(resp)
        },
        getData() {
            this.$api.get(`/clients/${this.client.id}/employees/${this.employee.id}/accrual-plans`).then(resp => {
                this.setData(resp)
            }).catch(errors => {
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
